import { ColumnState } from 'ag-grid-community'

import { User } from '@/types/unlock'

import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type StateType = {
  stagesBarOpen: boolean
  selectedAppId?: string
  stage?: string
  search?: string
  selectedStaff: User[]
  viewAll: boolean
  currentPresetId?: string
  scrolledGrid: boolean
  columnState?: ColumnState[]
}

const initialState: StateType = {
  stagesBarOpen: true,
  stage: 'pending-app-submit',
  selectedStaff: [],
  viewAll: false,
  scrolledGrid: false,
}

const workQueuesSlice = createSlice({
  name: 'workQueues',
  initialState,
  reducers: {
    setSelectedAppId: (state, action: PayloadAction<string>) => {
      state.selectedAppId = action.payload
    },
    setStagesBarOpen: (state, action: PayloadAction<boolean>) => {
      state.stagesBarOpen = action.payload
    },
    setStage: (state, action: PayloadAction<string>) => {
      state.stage = action.payload
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload
    },
    setSelectedStaff: (state, action: PayloadAction<User[]>) => {
      state.selectedStaff = action.payload
    },
    setViewAll: (state, action: PayloadAction<boolean>) => {
      state.viewAll = action.payload
    },
    setCurrentPresetId: (state, action: PayloadAction<string>) => {
      state.currentPresetId = action.payload
    },
    setColumnState: (state, action: PayloadAction<ColumnState[]>) => {
      state.columnState = action.payload
    },
    setScrolledGrid: (state, action: PayloadAction<boolean>) => {
      state.scrolledGrid = action.payload
    },
    clearFilters: (state) => {
      state.viewAll = false
      state.search = ''
      state.selectedStaff = []
      state.stage = 'pending-app-submit'
    },
  },
})

export const {
  setSelectedAppId,
  setStage,
  setSearch,
  setStagesBarOpen,
  setSelectedStaff,
  setViewAll,
  setCurrentPresetId,
  setColumnState,
  setScrolledGrid,
  clearFilters,
} = workQueuesSlice.actions

export const workQueuesReducer = workQueuesSlice.reducer
